module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/br-b3663866f502ec386f0ee9bc6df5ecdc.svg";